module.exports = __webpack_public_path__ + "img/中文.026d2a3d.svg";